export default __webpack_public_path__ + "static/media/2_icon3A.201c56f4.png";